import { Img } from '@euler/components/image/AdvancedImage';
import { memo, useState } from 'react';
import { StyleProp } from 'react-native';
import { ImageStyle } from 'react-native-fast-image';

export const VehicleBrandLogo = memo(
  ({
    url,
    height,
    style,
  }: {
    url?: string;
    height: number;
    style?: StyleProp<ImageStyle>;
  }) => {
    const [width, setWidth] = useState<number>();
    if (url == null) return null;
    if (width == null) {
      return (
        <Img
          uri={url}
          onLoad={e => {
            setWidth((e.width / e.height) * height);
          }}
          css={`
            width: ${height}px;
            height: ${height}px;
          `}
        />
      );
    }
    return (
      <Img
        uri={url}
        css={`
          width: ${width}px;
          height: ${height}px;
        `}
        resizeMode="cover"
        style={style}
      />
    );
  },
);
